module.exports = __webpack_public_path__ + "img/GR075.c6985307.png";